module["exports"] = [
  "com",
  "az",
  "com.az",
  "info",
  "net",
  "org"
];
